module.exports = {
	"src": [
		"audio.ogg",
		"audio.mp3"
	],
	"sprite": {
		"barkDucks": [
			0,
			2403.265306122449
		],
		"champ": [
			4000,
			9639.183673469388
		],
		"gunSound": [
			15000,
			504.01360544217687
		],
		"laugh": [
			17000,
			1368.0045351473923
		],
		"loserSound": [
			20000,
			3631.0204081632664
		],
		"ohYeah": [
			25000,
			1071.020408163264
		],
		"quacking": [
			28000,
			6817.959183673466,
			true
		],
		"quak": [
			36000,
			783.6734693877575
		],
		"sniff": [
			38000,
			1985.306122448982,
			true
		],
		"thud": [
			41000,
			548.571428571428
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./dist/audio.json
// module id = 280
// module chunks = 0